import type { AxiosProgressEvent, AxiosRequestConfig, AxiosResponse } from 'axios';
import { getMediaModuleAxiosInstance } from '#client';
import type { MediaDataObject } from '#models/services';
import { routes } from '#routes';

export type MediaUploadProgressEvent = {
  percent: number;
} & AxiosProgressEvent;

export const createMedia = async ({
  file,
  onProgress,
  signal,
}: {
  file: Blob | File;
  onProgress?: (event: MediaUploadProgressEvent) => void;
  signal?: AbortSignal;
}) => {
  const uploadFormData: FormData = new FormData();
  const config: AxiosRequestConfig = {
    headers: { 'content-type': 'multipart/form-data' },
    onUploadProgress({ loaded, total, ...rest }) {
      const divisor = total ?? loaded;

      onProgress?.({
        loaded,
        percent: divisor > 0 ? Math.floor((loaded / divisor) * 100) : 0,
        total,
        ...rest,
      });
    },
    signal,
  };

  uploadFormData.append('file', file);
  uploadFormData.append('name', 'name' in file ? file.name : 'unknown_name');
  uploadFormData.append('size', file.size.toString());
  uploadFormData.append('type', 'chatroom_attachement');
  uploadFormData.append('mimeType', file.type);

  return getMediaModuleAxiosInstance().post<MediaDataObject, AxiosResponse<MediaDataObject>>(
    routes.media.create,
    uploadFormData,
    config,
  );
};
